var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3149 13.738C33.3149 13.404 33.1739 13.105 32.9099 12.859L21.1679 1.082C20.8339 0.748001 20.5349 0.625 20.2189 0.625C19.5509 0.625 19.0589 1.117 19.0589 1.768C19.0589 2.102 19.1639 2.4 19.3749 2.628L24.6309 7.938L29.8169 12.754L25.7389 12.56H1.83188C1.16388 12.56 0.671875 13.053 0.671875 13.738C0.671875 14.424 1.16388 14.916 1.83188 14.916H25.7389L29.8339 14.723L24.6309 19.539L19.3749 24.848C19.1649 25.058 19.0589 25.375 19.0589 25.691C19.0589 26.341 19.5509 26.834 20.2189 26.834C20.5349 26.834 20.8169 26.728 21.0799 26.482L32.9099 14.617C33.1739 14.371 33.3149 14.072 33.3149 13.738Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowNext);
export default __webpack_public_path__ + "static/media/slider-arrow-next.bcd064ca0153eea4fbf00a39263bd9ef.svg";
export { ForwardRef as ReactComponent };